<template>
  <!-- Button trigger modal -->
  <!-- Modal -->
  <div
    class="modal fade"
    id="mid_header_location"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Select Location</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" v-if="outOfRange">
          <div class="vertical-center">
            <div class="text-center">
              <h1>S<i class="fas fa-sad-cry"></i>rry!</h1>
              <h5>
                Unfortunately, it looks like CalsoB isn't available in your
                area yet.
              </h5>
              <div class="redirect-link-wrapper u-s-p-t-25">
                <a
                  class="redirect-link"
                  href="#"
                  @click="redirectLocationSelection"
                >
                  <span>Return to Location Selection</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body" v-if="!outOfRange">
          <GMapAutocomplete
            placeholder="Enter Your Address"
            @place_changed="setPlace($event)"
            class="form-control p-2"
            ref="gmapAutocomplete"
          >
          </GMapAutocomplete>
          <GMapMap
            :center="center"
            :zoom="zoom"
            style="width: 500px; height: 300px"
            ref="myMapRef"
            @click="handleClick($event)"
          >
            <GMapCluster>
              <GMapMarker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                :clickable="true"
                :draggable="false"
                @click="center = m.position"
                @position_changed="updateCoordinates($event)"
              />
            </GMapCluster>
          </GMapMap>
        </div>
        <div class="modal-footer" v-if="!outOfRange">
          <button
            type="button"
            class="button button-primary mt-4"
            @click="save"
          >
            {{ saving ? "Saving..." : "Save Changes" }}
          </button>
          <button
            type="button"
            class="button button-primary mt-4"
            @click="setCurrentLocation"
            :disabled="loading"
          >
            {{ loading ? "Please Wait.." : "Use current location" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import { checkInRange } from "../../utils/common_functions";
export default {
  computed: mapGetters("auth", ["user"]),
  props: ["current_address"],
  data() {
    return {
      showLocationButton: false,
      center: { lat: 51.093048, lng: 6.84212 },
      address: "",
      search: false,
      loading: false,
      saving: false,
      zoom: 7,
      outOfRange: false,
      markers: [
        {
          position: {
            lat: 51.093048,
            lng: 6.84212,
          },
        }, // Along list of clusters
      ],
    };
  },
  methods: {
    ...mapActions("auth", ["updateUserDetails"]),
    //setting geo cords by google autocomplete api
    setPlace(event) {
      console.log(
        "Selected Latitude: " + event.geometry.location.lat(),
        "Selected Longitude: " + event.geometry.location.lng()
      );
      this.search = true;
      this.center = {
        lat: event.geometry.location.lat(),
        lng: event.geometry.location.lng(),
      };
      this.markers[0].position = event.geometry.location;
      this.zoom = 17;
      this.address = event.name + ", " + event.formatted_address;
    },

    async save() {
      this.saving = true;
      if (!this.search) {
        let address = await this.getAddressFrom(
          //getting address from google api
          this.center.lat,
          this.center.lng
        );
        // console.log(address);
        this.address = address[0].formatted_address;
        // this.saveAddressToDB();
      }
      this.search = false;
      let LatLng = JSON.stringify({
        lat: this.center.lat,
        lng: this.center.lng,
      });

      try {
        let res = await checkInRange(this.center.lat, this.center.lng);
        //check if warehouse is in range
        console.log('Any Warehouse in Range', res);
        if (res == true) {
          //if warehouse is in range then save it in local storage and reload the page
          localStorage.setItem("location", LatLng);
          window.location.reload();
          // $("#mid_header_location").modal("hide");
          this.outOfRange = false;
        } else {
          //if warehouse is not in range then show error message
          this.outOfRange = true;
        }
        this.saving = false;
      } catch (error) {
        this.saving = false;
        console.log(error);
      }
    },

    redirectLocationSelection() {
      //redirect to location selection page
      let cord = {
        lat: this.current_address.LatLng.lat,
        lng: this.current_address.LatLng.lng,
      };
      this.markers[0].position = cord;
      this.center = cord;
      this.outOfRange = false;

      // i don't think this is good practice :P
      setTimeout(() => {
        this.$refs.gmapAutocomplete.$refs.input.value =
          this.current_address.formatted_address;
      }, 2000);
    },
    handleMarkerClick() {},

    //when somone click on map
    handleClick(event) {
      this.search = false;
      let cord = { lat: event.latLng.lat(), lng: event.latLng.lng() };
      console.log(cord);
      this.markers[0].position = cord;
      this.center = cord;
    },

    //useless function
    updateCoordinates(location) {
      let cord = { lat: location.lat(), lng: location.lng() };
      this.center = cord;
    },

    //form lat and lng we are getting array of result
    getAddressFrom(lat, lng) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axios.get(
            "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
              lat +
              "," +
              lng +
              "&key=AIzaSyA9Az_2wI5BBoLGDkkC8xXxO3b0pVtsGuU"
          );
          return resolve(res.data.results);
        } catch (error) {
          return reject(error);
        }
      });
    },

    async saveAddressToDB() {
      let data = {
        latitude: this.center.lat,
        longtitude: this.center.lng,
        full_address: this.address,
        user_id: 1,
      };
      try {
        let res = await axios.post(
          process.env.VUE_APP_API_URL + "/api/user/changeAddress",
          data
        );
        console.log(res);
      } catch (error) {
        console.log(error);
      }
    },

    //getting current location
    setCurrentLocation() {
      navigator.geolocation.getCurrentPosition(
        ({ coords: { latitude, longitude } }) => {
          console.log(latitude, longitude);
          //intial Load
          if (latitude && longitude) {
            this.loading = true;
          }
          this.getAddressFrom(latitude, longitude).then((res) => {
            if (this.$refs.gmapAutocomplete) {
              this.$refs.gmapAutocomplete.$refs.input.value =
                res[0].formatted_address;
            }
            this.loading = false;
          });
          let latlng = { lat: latitude, lng: longitude };
          this.center = latlng;
          this.markers[0].position = latlng;
          this.showLocationButton = true;
          this.zoom = 17;
          this.search = false;
        }
      );
    },
  },
  mounted() {
    console.log(this.current_address);
    // this.setCurrentLocation();
    // console.log(process.env.VUE_APP_API_URL)
  },
  watch: {
    current_address: function (val) {
      // watch it
      (this.$refs.gmapAutocomplete.$refs.input.value = val.formatted_address),
        (this.center = val.LatLng);
      this.markers[0].position = val.LatLng;
      this.zoom = 17;
    },
  },
};
</script>

<style>
.modal {
  z-index: 20 !important;
}
.modal-backdrop {
  z-index: 10;
}
.pac-container {
  background-color: #fff;
  z-index: 20;
  position: fixed;
  display: inline-block;
  float: left;
}
.vue-map-container {
  height: 100%;
}
.modal-body {
  height: 400px;
}
.modal-header{
  display: flex;
}
</style>
